import React from 'react';

import './maintenance.scss';

export default (props) => {
	return (
		<div className={`maintenance${props.isMobile ? ' mobile' : ''}`}>
			<p className="alert-header">
				Scheduled Maintenance: {props.dateString}
			</p>
			<p className="alert-text">
				The Narrativ dashboard will be unavailable while we perform routine server upgrades.
			</p>
		</div>
	);
};
